import { render, staticRenderFns } from "./BrewerySiteInspectionList.vue?vue&type=template&id=8f368376&scoped=true"
import script from "./BrewerySiteInspectionList.vue?vue&type=script&lang=js"
export * from "./BrewerySiteInspectionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f368376",
  null
  
)

export default component.exports